import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';

import css from './ChoiceNotFound.module.scss';

type ChoiceNotFoundProps = {
    value: string;
    customClass?: string;
};

const ChoiceNotFound = ({ value, customClass }: ChoiceNotFoundProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);
    return (
        <div className={`${css.choice_not_found_wrapper} ${customClass || ''}`}>
            <Text customClass={css.text} variant={'body_00'} color={'txt-primary'}>
                {t('settings.revives.no-choice-found')}
                <br />
                &quot;{value}&quot;
            </Text>
        </div>
    );
};
export default ChoiceNotFound;
